import * as React from 'react';
import { cn } from './cn';

export interface SeparatorProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: 'horizontal' | 'vertical';
  /** Purely decorative separators are hidden from assistive tech. */
  decorative?: boolean;
  /** Optional centred label ("או" / "or"). Horizontal only. */
  label?: React.ReactNode;
}

/** Hairline divider in `--color-line`. */
export const Separator = React.forwardRef<HTMLDivElement, SeparatorProps>(function Separator(
  { orientation = 'horizontal', decorative = true, label, className, ...props },
  ref,
) {
  const a11y = decorative
    ? ({ role: 'none' } as const)
    : ({ role: 'separator', 'aria-orientation': orientation } as const);

  if (label && orientation === 'horizontal') {
    return (
      <div ref={ref} className={cn('flex items-center gap-3', className)} {...a11y} {...props}>
        <span className="h-px flex-1 bg-line" />
        <span className="text-2xs font-medium tracking-wide text-ink-3 uppercase">{label}</span>
        <span className="h-px flex-1 bg-line" />
      </div>
    );
  }

  return (
    <div
      ref={ref}
      className={cn(
        'shrink-0 bg-line',
        orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px self-stretch',
        className,
      )}
      {...a11y}
      {...props}
    />
  );
});
